import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchResiliencDropdownFiltersAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-risk/dropdown-filters`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RESILIENC_DROPDOWN_FILTERS_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchResiliencFilterAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-risk/filters-api`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RESILIENC_FILTER_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchResilincMainAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-risk/resilinc-main-page-details`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RESILINC_MAIN_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchResilincDetailAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-risk/resilinc-kpi-page-details`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RESILINC_DETAIL_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchResilincFilterAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-risk/resilinc-filters-api`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RESILINC_FILTER_ACTION' }, data);
        dispatch(resData);
    };
};

export { FetchResiliencFilterAction, FetchResiliencDropdownFiltersAction,FetchResilincMainAction,FetchResilincDetailAction,FetchResilincFilterAction }